import React, {Component} from 'react';
import firebase from "firebase";
import {Card, Table, Button, Row, Col} from 'elemental-react16';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import { CSVLink } from 'react-csv';
//import axios from "axios/index";


class Order extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isShownProduct: false,
            textButtonProduct: 'Show',
            userSessionId: 0
        };
    }

    toggleShowingProduct = () => {
        this.setState((prevState) => {
            return {
                isShownProduct: !prevState.isShownProduct,
                textButtonProduct: (prevState.textButtonProduct === 'Hide') ? 'Show' : 'Hide'
            }
        })
    };

    confirmPayment = (type) => {
        this.props.ordersReference
            .child(this.props.postId)
            .child(this.props.idOrder)
            .update({
                isPaidCc: type === 1
            });
        this.props.updateOrders();
    };

    cancelOrder = (idOrder) => {
        this.props.ordersReference
            .child(this.props.postId)
            .child(idOrder)
            .update({
                isOrderCancelled: true
            }).then(() => {
            this.props.products.map((val) => {
                //let availableNew = val.available + val.quantity;
                this.props.productsInstance.child(val.id).update({
                    available: val.available
                });
            });
        });
        this.props.updateOrders();
    };

    parseNum = (num) => {
        return num.toLocaleString(undefined, {minimumFractionDigits: 2});
    };

    render() {

        let status = '',
            statusIcon = '',
            statusColor = '';

        if (this.props.isOrderCancelled && this.props.isOrderConfirmed && !this.props.isPaidCc) {
            status = 'Cancelled';
            statusIcon = 'trash-alt';
            statusColor = 'icon-reded';
        } else if (!this.props.isPaidCc && !this.props.isOrderDone) {
            status = 'Pending';
            statusIcon = 'clock';
            statusColor = 'icon-greyed';
        } else if (!this.props.isOrderCancelled && this.props.isPaidCc && !this.props.isOrderDone) {
            status = 'Paid';
            statusIcon = 'money-bill-alt';
            statusColor = 'icon-blued';
        } else if (this.props.isOrderDone && this.props.isPaidCc) {
            status = 'Completed';
            statusIcon = 'check-circle';
            statusColor = 'icon-greened';
        }

        let total = 0;
        return (
            <tr style={this.props.isOrderCancelled ? {opacity: 0.4} : {opacity: 1}}>
                <td className="row-centered">{this.props.idOrder}</td>
                <td className="row-centered">
                    <Button size="sm"
                            type="hollow-primary"
                            onClick={this.toggleShowingProduct} style={this.state.isShownProduct ? {marginBottom: 20} : {}}>
                        {this.state.textButtonProduct}
                    </Button>
                    {
                        this.state.isShownProduct &&
                        <Row className="titles">
                            <Col xs="10%" sm="10%" lg="10%">ID</Col>
                            <Col xs="10%" sm="10%" lg="10%">Image</Col>
                            <Col xs="50%" sm="50%" lg="50%">Title</Col>
                            <Col xs="15%" sm="15%" lg="15%">Price</Col>
                            <Col xs="5%" sm="5%" lg="5%">Quantity</Col>
                        </Row>
                    }
                    {
                        this.props.products &&
                        this.props.products.map((val, key) => {
                        total += (val.price * val.quantity);
                        return (
                            this.state.isShownProduct &&
                            <div>
                                <Row key={key} style={{alignItems: 'center', justifyContent: 'center'}}>
                                    <Col xs="10%" sm="10%" lg="10%">{val.idProd}</Col>
                                    <Col xs="10%" sm="10%" lg="10%"><img src={val.image} alt={val.name} width={70}/></Col>
                                    <Col xs="50%" sm="50%" lg="50%">{val.name}</Col>
                                    <Col xs="15%" sm="15%" lg="15%">&euro; {this.parseNum(val.price)}</Col>
                                    <Col xs="5%" sm="5%" lg="5%">{val.quantity}</Col>
                                </Row>
                            </div>
                        )
                    })}
                </td>
                <td className="row-centered">&euro; {this.parseNum(total)}</td>
                <td className="row-centered">{this.props.timestamp}</td>
                <td className="row-centered">
                    <Button type="hollow-success"
                            onClick={() => {
                                if (window.confirm('Are you sure to confirm this order with Credit Card payment?')) this.confirmPayment(1)
                            }}
                            disabled={!!(this.props.isPaidCc || this.props.isOrderCancelled)}>
                        <i className="far fa-credit-card"/>&nbsp;&nbsp;
                        Confirm{this.props.isPaidCc ? 'ed' : ''}

                    </Button>
                </td>
                <td className="row-centered">
                    <i className={`far fa-${statusIcon} ${statusColor}`}/>
                    &nbsp;&nbsp;<span className={`${statusColor}`}>{status}</span>
                </td>
                {
                    (status === 'Pending') ?
                        <td className="row-centered">
                            <i className="far fa-trash-alt"
                               style={{fontSize: 18, color: '#F6A29A', cursor: 'pointer'}}
                               onClick={() => {
                                   if (window.confirm('Are you sure to cancel this order?')) this.cancelOrder(this.props.idOrder)
                               }}/>
                        </td> :
                        <td className="row-centered">-</td>
                }
            </tr>
        )
    }
}

class SubscribersDiscount extends Component {

    render() {

        return (
            <tr>
                <td>{this.props.name}</td>
                <td>{this.props.email}</td>
                <td>{this.props.timestamp}</td>
            </tr>
        )
    }
}

class SubscribersMaldives extends Component {

    render() {

        return (
            <tr>
                <td>{this.props.email}</td>
                <td>{this.props.timestamp}</td>
            </tr>
        )
    }
}

class Orders extends Component {
    constructor(props) {
        super(props);

        this.state = {
            orders: [],
            subscribersDiscount: [],
            subscribersMaldives: [],
            ordersReference: null,
            subscribersDiscountReference: null,
            subscribersMaldivesReference: null,
            canDownload: false,
            selectedTab: 0
        };
    }

    uniqBy = (originalArray, prop) => {
        let newArray = [];
        let lookupObject  = {};

        for(let i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
        }

        for(let i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    };

    createOrderArray = (snapshot, orders) => {

        snapshot.forEach(function (data) {
            orders.unshift({
                idOrder: data.key,
                products: data.val().products,
                shippingData: data.val().shippingData,
                timestamp: data.val().timestamp,
                postId: data.val().postId,
                isPaidCc: data.val().isPaidCc,
                isOrderCancelled: data.val().isOrderCancelled,
                isOrderConfirmed: data.val().isOrderConfirmed,
                isOrderDone: data.val().isOrderDone
            });
        });
        this.getOrders(orders);
    };

    createSubscribersDiscountArray = (snapshot, subscribersDiscount) => {
        subscribersDiscount.unshift({
            email: (snapshot.val().email).toLowerCase(),
            name: snapshot.val().name,
            timestamp: snapshot.val().timestamp
        });
        this.getSubscribersDiscount(subscribersDiscount);
    };

    createSubscribersMaldivesArray = (snapshot, subscribersMaldives) => {
        subscribersMaldives.unshift({
            email: (snapshot.val().email).toLowerCase(),
            timestamp: snapshot.val().timestamp
        });
        this.getSubscribersMaldives(subscribersMaldives);
    };

    getOrders = (orders) => {
        this.setState({
            orders: orders
        }, () => {

            this.headersOrders = [
                'idOrder', 'timestamp', 'country', 'firstName', 'lastName',
                'billingAddress1', 'billingAddress2', 'billingCity', 'billingState', 'billingZip', 'billingCountry',
                'vatNumber', 'shippingAddress1', 'shippingAddress2', 'shippingCity', 'shippingState', 'shippingZip', 'shippingCountry',
                'phone', 'email', 'productId', 'productName', 'qty', 'price', 'eventName', 'privacyConsentShipping', 'privacyConsentPromotional'
            ];

            this.exportCsvOrders = [];

            orders.length > 0 &&
            orders.map((valOrder) => {
                let shippingD = valOrder.shippingData;

                valOrder.products &&
                valOrder.products.map((valProd) => {
                    (shippingD && valOrder.isOrderDone && !valOrder.isOrderCancelled) &&
                    this.exportCsvOrders.push([
                        valOrder.idOrder,
                        valOrder.timestamp,
                        'it',
                        shippingD.firstName,
                        shippingD.lastName,
                        shippingD.address1Billing,
                        shippingD.address2Billing,
                        shippingD.cityBilling,
                        shippingD.stateBilling,
                        shippingD.zipBilling,
                        shippingD.countryBilling,
                        shippingD.vatNumber,
                        shippingD.address1,
                        shippingD.address2,
                        shippingD.city,
                        shippingD.state,
                        shippingD.zip,
                        shippingD.country,
                        shippingD.phone,
                        shippingD.email,
                        valProd.idProd,
                        valProd.name,
                        valProd.quantity,
                        valProd.price,
                        'FuoriSalone',
                        'yes',
                        shippingD.promotionAccept === true ? 'yes' : 'no'
                    ]);
                });
            });
        });
    };

    getSubscribersDiscount = (subscribersDiscount) => {
        subscribersDiscount = this.uniqBy(subscribersDiscount, 'email');
        this.setState({
            subscribersDiscount: subscribersDiscount
        }, () => {

            this.headersSubscribers = [
                'email', 'name', 'timestamp', 'eventName', 'privacyConsentPromotional'
            ];

            this.exportCsvSubscribers = [];

            subscribersDiscount.length > 0 &&
            subscribersDiscount.map((subscriber) => {
                this.exportCsvSubscribers.push([
                    subscriber.email,
                    subscriber.name,
                    subscriber.timestamp,
                    'FuoriSalone',
                    'yes'
                ]);
            });
        });
    };

    getSubscribersMaldives = (subscribersMaldives) => {
        subscribersMaldives = this.uniqBy(subscribersMaldives, 'email');
        this.setState({
            subscribersMaldives: subscribersMaldives
        }, () => {

            this.headersSubscribersMaldives = [
                'email', 'eventName', 'timestamp', 'privacyConsentPromotional'
            ];

            this.exportCsvSubscribersMaldives = [];

            subscribersMaldives.length > 0 &&
            subscribersMaldives.map((subscriber) => {
                this.exportCsvSubscribersMaldives.push([
                    subscriber.email,
                    'FuoriSalone',
                    subscriber.timestamp,
                    'yes'
                ]);
            });
        });
    };

    updateOrders = () => {
        let orders = [];
        this.app.child('orders').on('child_added', snapshot => {
            this.createOrderArray(snapshot, orders);
        });
    };

    updateSubscribersDiscount = () => {
        let _self = this;
        let subscribersDiscount = [];
        this.app.child('subscribersDiscount').on('child_added', snapshot => {
            _self.createSubscribersDiscountArray(snapshot, subscribersDiscount);
        });
    };

    updateSubscribersMaldives = () => {
        let _self = this;
        let subscribersMaldives = [];
        this.app.child('subscribers').on('child_added', snapshot => {
            _self.createSubscribersMaldivesArray(snapshot, subscribersMaldives);
        });
    };

    handleChangeTab = (i, lastIndex) => {
        this.setState({
            selectedTab: i
        })
    };

    componentWillMount() {
        this.app = firebase.database().ref('/');

        let ordersReference = this.app.child('orders');
        let subscribersDiscountReference = this.app.child('subscribersDiscount');
        let subscribersMaldivesReference = this.app.child('subscribers');
        let productsInstance = this.app.child('products');

        let orders = [];
        ordersReference.on('child_added', snapshot => {
            this.createOrderArray(snapshot, orders);
        });

        ordersReference.on('value', () => {
            this.updateOrders();
        });

        let subscribersDiscount = [];
        subscribersDiscountReference.on('child_added', snapshot => {
            this.createSubscribersDiscountArray(snapshot, subscribersDiscount);
        });

        subscribersDiscountReference.on('value', () => {
            this.updateSubscribersDiscount();
        });

        let subscribersMaldives = [];
        subscribersMaldivesReference.on('child_added', snapshot => {
            this.createSubscribersMaldivesArray(snapshot, subscribersMaldives);
        });

        subscribersMaldivesReference.on('value', () => {
            this.updateSubscribersMaldives();
        });

        this.setState({
            ordersReference: ordersReference,
            subscribersDiscountReference: subscribersDiscountReference,
            subscribersMaldivesReference: subscribersMaldivesReference,
            productsInstance: productsInstance
        });
    }

    render() {
        let currentDatetime = new Date().toLocaleDateString('it-IT'),
            csvLink = '';

        if (this.state.selectedTab === 0) {
            if (this.exportCsvOrders && this.exportCsvOrders.length > 0) {
                csvLink = (
                    <CSVLink data={this.exportCsvOrders}
                             headers={this.headersOrders}
                             separator={";"}
                             filename={`export-orders-${currentDatetime}.csv`}>
                        <Button
                            type="primary"
                            className="export-csv"
                            disabled={this.state.orders.length === 0}>Export to CSV
                        </Button>
                    </CSVLink>)
            }
        } else if (this.state.selectedTab === 1) {
            if (this.exportCsvSubscribers && this.exportCsvSubscribers.length > 0) {
                csvLink = (
                    <CSVLink data={this.exportCsvSubscribers}
                             headers={this.headersSubscribers}
                             separator={";"}
                             filename={`export-subscribers-${currentDatetime}.csv`}>
                        <Button
                            type="primary"
                            className="export-csv"
                            disabled={this.state.subscribersDiscount.length === 0}>Export to CSV
                        </Button>
                    </CSVLink>)
            }
        } else {
            if (this.exportCsvSubscribersMaldives && this.exportCsvSubscribersMaldives.length > 0) {
                csvLink = (
                    <CSVLink data={this.exportCsvSubscribersMaldives}
                             headers={this.headersSubscribersMaldives}
                             separator={";"}
                             filename={`export-subscribers-maldives-${currentDatetime}.csv`}>
                        <Button
                            type="primary"
                            className="export-csv"
                            disabled={this.state.subscribersDiscount.length === 0}>Export to CSV
                        </Button>
                    </CSVLink>)
            }
        }

        return (
            <Card style={{margin: 10}}>
                <h5 style={{float: 'right'}}>
                    <a href="javascript:void(0)" onClick={this.props.handleLogout}>Logout</a>
                </h5><br/>
                {csvLink}
                <Tabs onSelect={(i, lastIndex) => this.handleChangeTab(i, lastIndex)}>
                    <TabList>
                        <Tab>Orders</Tab>
                        <Tab>Subscribers</Tab>
                        <Tab>Subscribers Maldives</Tab>
                    </TabList>

                    <TabPanel>
                        <Table>
                            <colgroup>
                                <col width="5%"/>
                                <col width="50%"/>
                                <col/>
                                <col/>
                                <col width="10%"/>
                                <col/>
                                <col width="8%"/>
                            </colgroup>
                            <thead>
                            <tr>
                                <th className="row-centered">Id Order</th>
                                <th className="row-centered">Ordered products</th>
                                <th className="row-centered">Order Total</th>
                                <th className="row-centered">Datetime</th>
                                <th className="row-centered">Confirm C/C Payment</th>
                                <th className="row-centered">Status</th>
                                <th className="row-centered">Cancel Order</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.orders.length > 0 ?
                                    this.state.orders.map((data, key) => {
                                        return (<Order key={key}
                                                       idOrder={data.idOrder}
                                                       products={data.products}
                                                       timestamp={data.timestamp}
                                                       postId={data.postId}
                                                       isPaidCc={data.isPaidCc}
                                                       isOrderCancelled={data.isOrderCancelled}
                                                       isOrderConfirmed={data.isOrderConfirmed}
                                                       isOrderDone={data.isOrderDone}
                                                       updateOrders={this.updateOrders}
                                                       ordersReference={this.state.ordersReference}
                                                       productsInstance={this.state.productsInstance}
                                        />)
                                    }) :
                                    <tr>
                                        <td className="no-orders-yet" colSpan={7}>No orders yet =(</td>
                                    </tr>
                            }
                            </tbody>
                        </Table>
                    </TabPanel>
                    <TabPanel>
                        <Table>
                            <colgroup>
                                <col width="33%"/>
                                <col width="33%"/>
                                <col width="33%"/>
                            </colgroup>
                            <thead>
                            <tr>
                                <th>Name and Surname</th>
                                <th>Email</th>
                                <th>Datetime</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.subscribersDiscount.length > 0 ?
                                    this.state.subscribersDiscount.map((data, key) => {
                                        return (<SubscribersDiscount key={key}
                                                                     name={data.name}
                                                                     email={data.email}
                                                                     timestamp={data.timestamp}/>
                                        )
                                    }) :
                                    <tr>
                                        <td className="no-orders-yet" colSpan={2}>No subscribers yet =(</td>
                                    </tr>
                            }
                            </tbody>
                        </Table>
                    </TabPanel>
                    <TabPanel>
                        <Table>
                            <colgroup>
                                <col width="50%"/>
                                <col width="50%"/>
                            </colgroup>
                            <thead>
                            <tr>
                                <th>Email</th>
                                <th>Datetime</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.subscribersMaldives.length > 0 ?
                                    this.state.subscribersMaldives.map((data, key) => {
                                        return (<SubscribersMaldives key={key}
                                                                     email={data.email}
                                                                     timestamp={data.timestamp}/>
                                        )
                                    }) :
                                    <tr>
                                        <td className="no-orders-yet" colSpan={2}>No subscribers yet =(</td>
                                    </tr>
                            }
                            </tbody>
                        </Table>
                    </TabPanel>
                </Tabs>
            </Card>
        )
    }
}


export default Orders;



// WEBPACK FOOTER //
// ./src/components/admin/Orders.js